import type { FC } from 'react';
import { gameEventIcons } from '../../MatchScores.constants';
import type { MatchAdditionalSegmentsProps } from './MatchAdditionalSegments.types';
import styles from './MatchAdditionalSegments.module.scss';
export const MatchAdditionalSegments: FC<MatchAdditionalSegmentsProps> = ({
  additionalSegments,
  scoreType,
  className
}) => {
  return <div className={cn(styles.root, styles[`${scoreType.toLowerCase()}Scores`], className)} data-sentry-component="MatchAdditionalSegments" data-sentry-source-file="MatchAdditionalSegments.tsx">
      {additionalSegments.map(([key, scores]) => {
      return <div key={key} className={styles.scoreWrapper}>
            <span className={styles.gameIconWrapper}>{gameEventIcons[key]}</span>
            <span>{scores[scoreType]}</span>
          </div>;
    })}
    </div>;
};